import { useFormContext } from 'react-hook-form'
import { MappedEnrichedEvent } from 'services/api/entities/events/types/internal/event-models'
import { ServiceCollectionName } from 'types/common'

const useSelections = <T extends ServiceCollectionName>(serviceName: T) => {
  const { getValues } = useFormContext<MappedEnrichedEvent>()

  const selections = getValues(serviceName)
  const hasSelections = selections?.length > 0

  return { selections, hasSelections }
}

export default useSelections
